import React from 'react';
import { connect } from 'react-redux';

const mapStateToProps = state => ({
  ...state.home,
  appName: state.common.appName
});

const mapDispatchToProps = dispatch => ({

});

class Business extends React.Component {
  componentWillMount() {

  }

  componentWillUnmount() {

  }

  render() {
    return (
      <div></div>

    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Business);



// WEBPACK FOOTER //
// ./src/views/Business.js